import { __ } from '@wordpress/i18n';
import {
	TextControl,
} from '@wordpress/components';
import ColorControl from '../../../controls/ColorControl';
const Tools = ({ item, index, itemIndex, handleChangeItemField, setAttributes, attributes }) => {
	const {
		toolsNameColor,
		toolsArrowColor,
		style,
	} = attributes || {};
	return (
		<>
			<TextControl
				label={__('Title', 'cv-builder')}
				value={item.name || ''}
				onChange={(value) =>
					handleChangeItemField(value, index, itemIndex, 'name')
				}
			/>
			{
				style !== 'style26' && style !== 'style27' && style !== 'style28' && (
					<>
				<ColorControl
					label={__(
					'Tools Title Color',
					'cv-builder'
					)}
					color={toolsNameColor}
					colorName="toolsNameColor"
					onChange={(colorObj) => setAttributes(colorObj)}
				/>
				<ColorControl
					label={__(
					'Arrow Color',
					'cv-builder'
					)}
					color={toolsArrowColor}
					colorName="toolsArrowColor"
					onChange={(colorObj) => setAttributes(colorObj)}
				/>
				</>
			)}
		</>
	);
};

export default Tools;
